import { Component, Input, OnInit } from '@angular/core';
import { ActiveStatusWithReasonDto } from 'src/api/models';

@Component({
  selector: 'app-desactivate-infos',
  templateUrl: './desactivate-infos.component.html',
  styleUrls: ['./desactivate-infos.component.css']
})
export class DesactivateInfosComponent implements OnInit {
  @Input() DesactivateInfos: ActiveStatusWithReasonDto;

  constructor() {}

  ngOnInit() {
  }
}
